import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import LoadingButton from '@mui/lab/LoadingButton';
import TextField from '@mui/material/TextField';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../store';
import { updateUserProfile } from '../../store/users/api';
import { setUserProfile } from '../../store/auth/authSlice';
import UserUpdateSchema from '../../validation/userUpdateSchema';
import { Box } from '@mui/material';

const Profile: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const userProfile = useAppSelector((state) => state.auth.user);
  // const organizationId = getItem(config.ORGANIZATION_ID);

  const { handleSubmit, values, handleChange, isSubmitting, errors, touched } =
    useFormik({
      initialValues: {
        id: userProfile.id,
        firstName: userProfile.firstName,
        lastName: userProfile.lastName,
        activeState: userProfile.activeState,
      },
      validationSchema: UserUpdateSchema,
      onSubmit: async (values) => {
        try {
          const response = await dispatch(updateUserProfile(values)).unwrap();
          dispatch(setUserProfile({ user: response }));
          navigate('/user/profile');
        } catch (error: any) {}
      },
    });

  return (
    <Grid
      item
      xs={12}
      md={6}
    >
      <Card sx={{ p: 3 }}>
        <form onSubmit={handleSubmit}>
          <Box
            sx={{
              display: 'grid',
              columnGap: 2,
              rowGap: 3,
              gridTemplateColumns: {
                xs: 'repeat(1, 1fr)',
                sm: 'repeat(2, 1fr)',
              },
            }}
          >
            <TextField
              id='firstName'
              name='firstName'
              label={'First Name'}
              fullWidth
              autoComplete='given-firstName'
              onChange={handleChange}
              value={values.firstName}
              error={Boolean(touched.firstName && errors.firstName)}
              helperText={
                Boolean(errors.firstName && touched.firstName) &&
                errors.firstName
              }
            />
            <TextField
              id='lastName'
              name='lastName'
              label={'Last Name'}
              fullWidth
              autoComplete='given-lastName'
              onChange={handleChange}
              value={values.lastName}
              error={Boolean(touched.lastName && errors.lastName)}
              helperText={
                Boolean(errors.lastName && touched.lastName) && errors.lastName
              }
            />
            {/* <TextField
              id='email'
              name='email'
              label={'Email'}
              fullWidth
              autoComplete='given-contactNumber'
              onChange={handleChange}
              value={values.email}
              error={Boolean(touched.email && errors.email)}
              helperText={
                Boolean(errors.email && touched.email) && errors.email
              }
            />
            <TextField
              id='contactNumber'
              name='contactNumber'
              label={'Contact Number'}
              fullWidth
              autoComplete='given-contactNumber'
              onChange={handleChange}
              value={values.contactNumber}
              error={Boolean(touched.contactNumber && errors.contactNumber)}
              helperText={
                Boolean(errors.contactNumber && touched.contactNumber) &&
                errors.contactNumber
              }
            /> */}
          </Box>

          <Stack
            alignItems='flex-end'
            sx={{ mt: 1.5 }}
          >
            <LoadingButton
              type='submit'
              variant='contained'
              loading={isSubmitting}
            >
              Update Profile
            </LoadingButton>
          </Stack>
        </form>
      </Card>
    </Grid>
  );
};

export default Profile;
